import {
  POST_ENDORSEMENT,
  POST_ENDORSEMENT_FULFILLED,
  POST_ENDORSEMENT_PENDING,
  POST_ENDORSEMENT_REJECTED
} from "../actions/types";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case POST_ENDORSEMENT_PENDING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case POST_ENDORSEMENT_FULFILLED:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: false,
      };
    case POST_ENDORSEMENT_REJECTED:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case POST_ENDORSEMENT:
      return {
        ...state,
        data: [],
      };
    default:
      return state;
  }
}
